import * as React from 'react'
import JsBarcode from 'jsbarcode'
import * as Sentry from '@sentry/browser'

export interface Props {
  value: string
  height: number
  hideValue?: boolean
  use128?: boolean
}

export class BarcodeRenderer extends React.Component<Props> {
  barcodeElementId = () => {
    return `barcode-${this.props.value}`
  }

  loadBarcode = () => {
    try {
      JsBarcode(`#${this.barcodeElementId()}`, this.props.value, {
        format: this.props.use128 ? 'code128' : 'code39',
        width: 1,
        height: this.props.height ? this.props.height : 40,
        displayValue: !this.props.hideValue,
        fontSize: 14
      })
    } catch (err) {
      Sentry.captureException(err)
    }
  }

  componentDidMount = async () => {
    this.loadBarcode()
  }

  render = () => (
    <div>
      <svg id={this.barcodeElementId()} />
    </div>
  )
}
